import { c as _c } from "react/compiler-runtime";
import { tv } from 'tailwind-variants';
import { base } from './base';
import type { ComponentPropsWithRef } from 'react';
import type { VariantProps } from 'tailwind-variants';
const overline = tv({
  extend: base,
  base: 'font-mono',
  variants: {
    size: {
      lg: 'text-[1rem] leading-6',
      md: 'text-[0.875rem] leading-5',
      sm: 'text-[0.75rem] leading-4'
    }
  },
  defaultVariants: {
    size: 'md',
    tracking: 'normal'
  }
});
export type OverlineVariants = VariantProps<typeof overline>;
type OverlineProps = ComponentPropsWithRef<'span'> & OverlineVariants;
function Overline(t0) {
  const $ = _c(18);
  let className;
  let disabled;
  let italic;
  let rest;
  let size;
  let tracking;
  let weight;
  if ($[0] !== t0) {
    ({
      className,
      size,
      weight,
      italic,
      disabled,
      tracking,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = disabled;
    $[3] = italic;
    $[4] = rest;
    $[5] = size;
    $[6] = tracking;
    $[7] = weight;
  } else {
    className = $[1];
    disabled = $[2];
    italic = $[3];
    rest = $[4];
    size = $[5];
    tracking = $[6];
    weight = $[7];
  }
  let t1;
  if ($[8] !== className || $[9] !== disabled || $[10] !== italic || $[11] !== size || $[12] !== tracking || $[13] !== weight) {
    t1 = overline({
      size,
      weight,
      italic,
      disabled,
      tracking,
      class: className
    });
    $[8] = className;
    $[9] = disabled;
    $[10] = italic;
    $[11] = size;
    $[12] = tracking;
    $[13] = weight;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  let t2;
  if ($[15] !== rest || $[16] !== t1) {
    t2 = <span className={t1} {...rest} />;
    $[15] = rest;
    $[16] = t1;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  return t2;
}
export { overline, Overline };